import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isAdminUser, isPremiumAllowed } from "@/components/access";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[#243B53] font-bold">Carregando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  const admin = isAdminUser(user);
  if (adminOnly && !admin) return <Navigate to="/app" replace />;

  if (!admin && !isPremiumAllowed(user)) {
    return <Navigate to="/assinatura" replace />;
  }
  return children;
}
